import type React from 'react';
import { useState, useEffect } from 'react';
import styles from './Carousel.module.scss';
import HeaderBanner from 'assets/headerBanner.png';
import { apiRequest, catchErrorMessageHandler } from '../../../infrastructure/backendService';
import { CMS_BASE_URL } from '../../../config/apiUrl';
import { isEmpty, isNil } from 'lodash';
import ToastError from '../../common/toast/toastError';
import toast from 'react-hot-toast';
import ErrorPopup from '../../common/ErrorPopup';
import constants from "../../../config/constants.json";


export default function Carousel(): React.ReactElement {
   const [isOpen, setIsOpen] = useState<boolean>(false);
   const [currentSlide, setCurrentSlide] = useState<number>(0);
   const [carousalData, setCarousalData] = useState([]);

   const slides: React.ReactNode[] = [
      <div key="1">
         <img src="./images/facilities-ban2.jpg" style={{ height: '280px', width: '100%' }} />
      </div>,
      <div key="2">
         <img src="./images/karthika-masa.jpg" style={{ height: '280px', width: '100%' }} />
      </div>,
      <div key="3">
         <img src="./images/cal-2024.jpg" style={{ height: '280px', width: '100%' }} />
      </div>,
      <div key="4">
         <img src="./images/ayyappa-mandala.jpg" style={{ height: '280px', width: '100%' }} />
      </div>,
      <div key="5">
         <img src="./images/annadana-banner.jpg" style={{ height: '280px', width: '100%' }} />
      </div>,
      <div key="6">
         <img src="./images/young-adult-program.jpg" style={{ height: '280px', width: '100%' }} />
      </div>,
      <div key="7">
         <img src="./images/mobile-app-banner.jpg" style={{ height: '280px', width: '100%' }} />
      </div>,
   ];

   useEffect(() => {
      apiRequest({
         basePath: `${CMS_BASE_URL}`,
         method: 'GET',
         endpoint: '/wp-json/wp/v2/carousel',
         includeToken: false
      })
         .then((res) => {
            const acfList = res.data.map((item: any) => item.acf);
            setCarousalData(acfList);
            console.log(acfList, "Acf List");
         })
         .catch((err) => {
            console.log(err);
            toast.custom(<ErrorPopup showMessage={catchErrorMessageHandler(err)} isOpen={isOpen} setIsOpen={setIsOpen} />, {
               duration: constants.TOAST_POPUP_DURATION,
             });
         });
   }, []);

   useEffect(() => {
      const intervalId = setInterval(() => {
         setCurrentSlide((prev) => (prev + 1) % carousalData.length);
      }, 5000);

      return () => {
         clearInterval(intervalId);
      };
   }, [carousalData.length]);

   const handleButtonClick = (index: number): void => {
      setCurrentSlide(index);
   };

   const onClickImage = (imagePath:string) =>{
      if(!isNil(imagePath) || !isEmpty(imagePath)) {
         window.open(imagePath,"_blank")
      }
   }

   return (
      <div className={styles.CarouselWrapper}>
         <div className={styles.CarouselContainer}>
            <div
               className={styles.SlideContainer}
               style={{ transform: `translateX(-${currentSlide * 100}%)` }}
            >
               {carousalData.map((slide: any, index) => (
                  <div className={`${styles.Slide} ${!isNil(slide.image_link) && !isEmpty(slide.image_link) ? styles.hovered : ''}`} key={index}>
                     <img
                        src={slide.image_url}
                        alt='image'
                        style={{ height: 'auto', width: '100%' }}
                        onClick={() => !isEmpty(slide.image_link) && onClickImage(slide.image_link)}
                     />
                  </div>
               ))}
            </div>
            <div className={styles.ButtonContainer}>
               {carousalData.map((_, index) => (
                  <button
                     key={index}
                     className={
                        index === currentSlide
                           ? `${styles.Button} ${styles.active}`
                           : `${styles.Button}`
                     }
                     onClick={() => {
                        handleButtonClick(index);
                     }}
                  />
               ))}
            </div>
         </div>
      </div>
   );
}
